import axios from 'axios';
import { API_BASE_URL } from './api';

export const topCleanersService = {
  // Get all top cleaners for a service
  getServiceTopCleaners: async (serviceId: number) => {
    const response = await axios.get(`${API_BASE_URL}/services/${serviceId}/top-cleaners`);
    return response.data;
  },

  // Add a new top cleaner
  addTopCleaner: async (serviceId: number, data: FormData) => {
    // Ensure icon field is present - if no icon file, add a default value
    if (!data.has('icon') || data.get('icon') === null) {
      // Provide a default icon or empty string to avoid null error
      data.append('icon', ''); // or use a default icon path if available
    }
    
    const response = await axios.post(`${API_BASE_URL}/services/${serviceId}/top-cleaners`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update a top cleaner
  updateTopCleaner: async (id: number, data: FormData) => {
    // Ensure icon field is present - if no icon file, add a default value
    if (!data.has('icon') || data.get('icon') === null) {
      // Provide a default icon or empty string to avoid null error
      data.append('icon', ''); // or use a default icon path if available
    }
    
    const response = await axios.put(`${API_BASE_URL}/services/top-cleaners/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete a top cleaner
  deleteTopCleaner: async (id: number) => {
    const response = await axios.delete(`${API_BASE_URL}/services/top-cleaners/${id}`);
    return response.data;
  },

  // Get available service providers that can be assigned as top cleaners
  getAvailableProviders: async () => {
    try {
      const url = `${API_BASE_URL}/staff/top-cleaners`;
      const response = await axios.get(url);
      console.log('📡 Top cleaners API response (from topCleanersService):', response.data);

      // Expected → response.data.data.staff
      if (response.data?.data?.staff) {
        const staff = response.data.data.staff;
        console.log('✅ Found staff array (from topCleanersService):', staff);
        // Normalize to expected format
        return staff.map((s: any) => ({
          sp_id: s.sp_id,
          name: s.sp_name,
          photo: s.photo || null
        }));
      }

      // fallback handlers
      if (response.data?.data) return response.data.data;
      if (response.data?.staff) return response.data.staff;
      if (Array.isArray(response.data)) return response.data;

      console.warn("Unexpected format (from topCleanersService):", response.data);
      return [];
    } catch (error) {
      console.error("Error fetching top cleaners (from topCleanersService):", error);
      return [];
    }
  }
};
